import { Symbols } from 'Symbols';
import { initValidators, IModelAttributeValidationError, ErrorType } from '../Util';
import { IndexableModel } from 'Models/Model';
import { isNullOrUndefined } from 'Util/TypeGuards';
import * as EmailValidator from 'email-validator';

export default function validate() {
	return (target: Record<string | symbol, any>, key: string) => {
		initValidators(target, key);
		target[Symbols.validatorMap][key].push('Email');
		target[Symbols.validator].push(
			(model: IndexableModel): Promise<IModelAttributeValidationError | null> =>
				new Promise(resolve => {
					if (model[key] === null || model[key] === undefined) {
						resolve(null);
					} else {
						resolve(
							isEmail(model[key])
								? null
								: {
										errorType: ErrorType.INVALID,
										errorMessage: 'The value is not a valid email',
										attributeName: key,
										target: model,
									},
						);
					}
				}),
		);
	};
}
export function isEmail(email?: string): boolean {
	if (isNullOrUndefined(email)) {
		return false;
	}

	return EmailValidator.validate(email);
}
